const prodConfig = {
    API_URL: "https://api.myodiopay.com/v1",
    BASE_URL: "https://api.myodiopay.com",
    PAYSTACK_PK: "pk_live_3a39803eb03032b3e3303eeda3ca5f7cafa369b0",
    okra: {
        env: "production",
        key: "306f2df1-5ecb-5d4e-ac4d-de5ab7224017",
        token: "5eeb30f1ac63db0684c8c1dc",
    },
};

const devConfig = {
    API_URL: "https://staging.api.myodiopay.com/v1",
    BASE_URL: "https://staging.api.myodiopay.com",
    PAYSTACK_PK: "pk_test_2a2a433e070e492f6d84c065f590a1a1314931c8",
    okra: {
        env: "production-sandbox",
        key: "7e5f00a8-89cd-5620-9c69-cfcb41eb7d99",
        token: "5eeb30f1ac63db0684c8c1dc",
    },
};

const generalConfig = {
    PASSWORD_PATTERN:
        "^(?=.*[A-Za-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$!%*#?&\\.]{8,}$",
    TOKEN_TYPE: "ODAD_Tokentype",
    TOKEN_NAME: "ODAD_Token",
};
export const config = {
    ...generalConfig,
    ...(process.env.REACT_APP_ENV === "production" ? prodConfig : devConfig),
};
